import { render } from "./GalleryGrid.vue?vue&type=template&id=64e0d01c&scoped=true"
import script from "./GalleryGrid.vue?vue&type=script&lang=js"
export * from "./GalleryGrid.vue?vue&type=script&lang=js"

import "./GalleryGrid.vue?vue&type=style&index=0&id=64e0d01c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e0d01c"],['__file',"src/scripts/sections/modules/gallery/GalleryGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64e0d01c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64e0d01c', __exports__)) {
    api.reload('64e0d01c', __exports__)
  }
  
  module.hot.accept("./GalleryGrid.vue?vue&type=template&id=64e0d01c&scoped=true", () => {
    api.rerender('64e0d01c', render)
  })

}


export default __exports__